module.exports = __webpack_public_path__ + "img/schnittkante_hellelfenbein_ral1015.676cec1d.jpg";